<template>
  <div
    class="flex gap-0.5 items-center"
    :class="{ 'bg-fill-brand px-1 rounded-md': isVip }"
  >
    <span
      class="text-text-on-brand text-sm font-semibold leading-tight break-good-singleline line-clamp-1"
      :class="textClass"
    >
      {{ username }}
    </span>
    <PremiumBadge
      v-if="isVip"
      class="shrink-0 simulfest:landscape:size-[2.6cqh] simulfest:portrait:size-[4cqw]"
      size="sm"
    />
  </div>
</template>

<script setup lang="ts">
import PremiumBadge from "@/components/badge/premium-badge.vue";

defineProps<{
  username: string;
  isVip?: boolean;
  textClass?: string;
}>();
</script>
